module.exports = __webpack_public_path__ + "static/media/radio.b8c61fd4.jpg";